import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { Gift } from "popups/Gift";
import { useDispatch, useSelector } from "react-redux";
import * as CUSTOM from "../../../../../utils/helper/custom";
import { Checkbox } from "@mui/material";
// import * as htmlToImage from "html-to-image";
import html2canvas from 'html2canvas';
import { changeTrigger } from "redux/reducers/trigger";
import { AddToMyOccasionAddNew } from "popups/AddToMyOccasionAddNew";
import {
  Button,
  Img,
  MobileInput,
  Input,
  Text,
  SelectBoxNew,
} from "components";
import {
  updateOrderData,
  getOrderData,
} from "../../../../../redux/reducers/orderData";
import { useAppFont } from "utils/helper/useAppFont";

const SendAsAGift = (props) => {
  const { occasionOptions, isEventSent, setIsEventSent, sendCheckoutGaEvent } = props;
  const orderData = useSelector(getOrderData);
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const printRef = useRef();
  const { interClass, interFamily, headingClass } = useAppFont();
  const [giftOpen, setgiftOpen] = useState(false);
  const [isLastOccassion, setIsLastOccassion] = useState(false);
  const [addToMyOccasionAddNewOpen, setAddToMyOccasionAddNewOpen] =
    useState(false);
  const [disabledBtn, setDisabledBtn] = useState(true);
  const [errors, setErrors] = useState({});
  const [cardForm, setCardForm] = useState({
    sender_name: "",
    recipient_name: "",
    country_code: "+966",
    mobile_no: "",
    email: "",
    occasion_id: 0,
    occasion_name: "",
    message: "",
    link: "",
    show_sender_name: 0,
    occasion_type_id:0
  });

  /**
   * get occation name by id
   */
  const setoccasion = (id) => {
    let data = occasionOptions.find((item) => item.value == id);
    if (data) {
      setCardForm({ ...cardForm, occasion_id: id, occasion_name: data?.label, occasion_type_id:data?.type});
    }
  };

  /**
   * gift  popup opem
   */
  const GiftOpenclick = () => {
    setgiftOpen(true);
    document.body.classList.add("overflow-hidden");
    document.getElementById("header-box").classList.add("relative");
  };

  /**
   * send gift form validations
   */
  const validForm = (data) => {
    let error = {};
    if (data?.mobile_no) {
      let mobileValidate = CUSTOM.isValidMobile(cardForm?.mobile_no, t);
      if (Object.keys(mobileValidate).length > 0) {
      error.mobile_no = mobileValidate;
      }
    } else {
      error.mobile_no = t("mobile_no_required");
    }
    if (!data?.recipient_name) {
      error.recipient_name = t("recipient_name_required");
    }
    if (!data?.sender_name && !data?.show_sender_name) {
      error.sender_name = t("sender_name_required");
    }

    if (!data?.occasion_id || data?.occasion_id == 0) {
      error.occasion_id = t("occasion_is_required");
    }
    if (data?.email) {
      if (!CUSTOM.isValidField(data?.email, "email")) {
        error.email = t("email_name_required");
      }
    }
    // else {
    //   error.email = t("email_name_required");
    // }
    if (!data?.message) {
      error.message = t("last_name_required");
    }
    // if (!data?.link) {
    //   error.link = t("url_is_required");
    // } else {
    //   if (!CUSTOM.isValidField(data?.link, "url")) {
    //     error.link = t("url_is_required");
    //   }
    // }
    if (data?.link && !CUSTOM.isValidField(data?.link, "url")) {
      error.link = t("url_is_required");
    }
    return error;
  };

  /*
   * set address data
   */
  // const deliverHear = () => {
  //   dispatch(
  //     updateOrderData({
  //       ...orderData,
  //       delivery_mode_show: "hide",
  //       home_office: {},
  //       buying_for_love: cardForm,
  //       pageStep: 4,
  //       delivery_mode: "buying_for_love",
  //     })
  //   );
  // };

  /**
   * convert gift image
   */
  // const convertGiftImage = async () => {
  //   const giftHtml = document.getElementById("gift-png-image-html");
  //   const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
  //   await delay(500);
  //   if (giftHtml) {
  //     try {
  //       const dataUrl = await htmlToImage.toPng(giftHtml);
  //       return dataUrl;
  //     } catch (error) {
  //       return "";
  //     }
  //   }
  // };

  /**
   * send gift data
   */
  const saveGiftData = async () => {
    let mobileValidate = CUSTOM.isValidMobile(cardForm?.mobile_no, t);
    if (Object.keys(mobileValidate).length > 0) {
      setErrors(mobileValidate);
      return;
    }
    if (Object.keys(validForm(cardForm)).length < 1) {
   //   let cardImage = await convertGiftImage();
      if (!isEventSent?.addShippingInfo) {
        setIsEventSent((prev) => ({ ...prev, addShippingInfo: true }));
        sendCheckoutGaEvent("add_shipping_info");
      }
      const element = printRef.current;
      const canvas = await html2canvas(element);
      const data = canvas.toDataURL("image/jpg");
      dispatch(
        updateOrderData({
          ...orderData,
          delivery_mode_show: "hide",
          home_office: {},
          buying_for_love: { ...cardForm, cardHtmlImage: data },
          pageStep: 4,
          delivery_mode: "buying_for_love",
        })
      );
    }
    setgiftOpen(false);
    CUSTOM.scrollTopBody();
    document.body.classList.remove("overflow-hidden");
    document.getElementById("header-box").classList.remove("relative");
  };

  /**
   * runtime check input field validations
   */
  useEffect(() => {
    let status = true;
    if (Object.keys(validForm(cardForm)).length < 1) {
      status = false;
    }
    setDisabledBtn(status);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cardForm]);

  /**
   * click and check tab
   */
  useEffect(() => {
    if (orderData?.delivery_mode == "buying_for_love") {
      setCardForm(orderData?.buying_for_love);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [orderData?.delivery_mode_show]);

  /**
   * refetch data
   */
  useEffect(() => {
    if (addToMyOccasionAddNewOpen == "refetch") {
      dispatch(changeTrigger("loadGiftOccasionList"));
      setIsLastOccassion(true);
      setAddToMyOccasionAddNewOpen(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [addToMyOccasionAddNewOpen]);

  useEffect(() => {
    if (isLastOccassion && occasionOptions.length > 0) {
      let data = occasionOptions[0];
      setCardForm({ ...cardForm, occasion_id: data?.value, occasion_name: data?.label, occasion_type_id:data?.type });
      setIsLastOccassion(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [occasionOptions]);

  /**
   * update data in state when reload page
   */
  useEffect(() => {
    if (orderData?.buying_for_love) {
      setCardForm(orderData?.buying_for_love);
    }
  }, [orderData?.buying_for_love]);

  return (
    <>
      <div className="w-full flex flex-col gap-5 px-1 pb-2">

        <h2
          className="text-[20px] font-medium leading-[28px]"
          style={{
            color: "var(--Blacks-900, #1A1A1A)",
            fontFamily: interFamily,
            fontStyle: "normal",
          }}
        >
          {t("giftInformation")}
        </h2>

        <div className="flex flex-row items-start gap-2 bg-[#FFF0F4] border border-[#F7C5D2] rounded-lg px-4 py-3">
          <span className="mt-0.5 shrink-0">
            <Img
              src="images/noteRemark.svg"
              alt="note icon"
              className="h-6 w-6 mt-0.5"
            />
          </span>
          <p
            className="text-[14px] font-medium leading-[20px]"
            style={{ fontFamily: interFamily }}
          >
            <span style={{ color: "var(--Main-Color-SubText, #8D4660)" }}>
              {t("pleaseNoteColon")}
            </span>
            <span style={{ color: "var(--Main-Color-Primary, #771237)" }}>
              {t(
                "onlyTheRecipientMayChooseTheDeliveryDateTimeAndPlaceWhenGivingTheseItemsAsGift"
              )}
            </span>
          </p>
        </div>

        <div className="flex flex-row xs:flex-col gap-4 w-full">
    
          <div className="flex flex-col gap-1 flex-1">
            <label className="text-sm text-gray-700 font-medium">
              {t("recipientName")}<span className="text-[#BD0043]">*</span>
            </label>
            <input
              type="text"
              placeholder={t("enterRecipientName")}
              value={cardForm?.recipient_name}
              onChange={(e) => {
                setCardForm({
                  ...cardForm,
                  recipient_name: CUSTOM.strFormat(e.target.value, "max:50"),
                });
              }}
              className="figma-input border border-gray-200 rounded-lg px-3 py-2.5 text-sm text-gray-800 placeholder-gray-200 focus:outline-none focus:border-[#BD0043] transition-colors bg-[white] w-full"
            />
          </div>

          <div className="flex flex-col gap-1 flex-1">
            <label className="text-sm text-gray-700 font-medium">
              {t("occasion")}<span className="text-[#BD0043]">*</span>
            </label>
            <div className="relative">
              <select
                value={cardForm?.occasion_id || ""}
                onChange={(e) => setoccasion(e.target.value)}
                className="figma-input border border-gray-200 rounded-lg px-3 py-2.5 text-sm text-gray-800 placeholder:text-gray-200 focus:outline-none focus:border-[#BD0043] transition-colors bg-[white] w-full appearance-none cursor-pointer"
              >
                <option value="" disabled>
                  {t("selectOccasion") || "Select occasion"}
                </option>
                {occasionOptions?.map((opt) => (
                  <option key={opt?.value} value={opt?.value}>
                    {opt?.label}
                  </option>
                ))}
              </select>
              <span className="pointer-events-none absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 text-xs">
                ▾
              </span>
            </div>
            <button
              type="button"
              className="flex flex-row items-center gap-1.5 mt-1 w-fit"
              onClick={() => setAddToMyOccasionAddNewOpen(true)}
            >
              <Img
                className="h-5 w-5"
                src="/images/img_plus_pink_800.svg"
                alt="add occasion"
              />
              <span className={`text-pink-800 text-sm ${interClass}`}>
                {t("addNewOccasion")}
              </span>
            </button>
          </div>
        </div>

        <div className="flex flex-row xs:flex-col gap-4 w-full">
          
          <div className="flex flex-col gap-1 flex-1">
            <label className="text-sm text-gray-700 font-medium">
              {t("recipientEmail") || t("email")}
            </label>
            <input
              type="email"
              placeholder={t("enterYourEmail") || "Enter your email"}
              value={cardForm?.email}
              onChange={(e) => {
                setCardForm({
                  ...cardForm,
                  email: CUSTOM.strFormat(e.target.value, "max:100"),
                });
              }}
              className="border border-gray-200 rounded-lg px-3 py-2.5 text-sm text-gray-800 placeholder-gray-400 focus:outline-none focus:border-[#BD0043] transition-colors bg-white w-full"
            />
          </div>

          <div className="flex flex-col gap-1 flex-1">
            <label className="text-sm text-gray-700 font-medium">
              {t("recipientPhoneNumber") || t("whatsappMobileNumber")}<span className="text-[#BD0043]">*</span>
            </label>
            <div
              className={`flex flex-row border rounded-lg overflow-hidden focus-within:border-[#BD0043] transition-colors bg-white ${
                errors?.mobile_no ? "border-red-400" : "border-gray-200"
              }`}
            >
              <div className="flex items-center gap-1.5 px-3 bg-gray-50 border-r border-gray-200 shrink-0">
                <Img
                  src="/images/img_iconeditorinsertlink.svg"
                  alt="whatsapp"
                  className="h-5 w-5"
                />
                <span className="text-sm text-gray-700 font-medium">
                  {cardForm?.country_code}
                </span>
              </div>
              <input
                type="tel"
                placeholder={t("whatsappMobileNumber") || "WhatsApp number"}
                value={cardForm?.mobile_no}
                onChange={(e) => {
                  setErrors({});
                  setCardForm({
                    ...cardForm,
                    mobile_no: CUSTOM.strFormat(e.target.value, "max:9|number"),
                  });
                }}
                className="px-3 py-2.5 text-sm text-gray-800 placeholder-gray-400 focus:outline-none bg-transparent w-full"
              />
            </div>
            {errors?.mobile_no && (
              <span className="text-xs text-red-500 mt-0.5">
                {errors.mobile_no}
              </span>
            )}
          </div>
        </div>

        <div className="flex flex-col gap-1 w-full">
          <label className="text-sm text-gray-700 font-medium">
            {t("messageCard") || t("typeYourCardMessageHere")}<span className="text-[#BD0043]">*</span>
          </label>
          <textarea
            placeholder={t("doYouHaveAnyNote") || "Do you have any note? Write here..."}
            value={cardForm?.message}
            onChange={(e) => {
              setCardForm({
                ...cardForm,
                message: CUSTOM.strFormat(e.target.value, "max:180"),
              });
            }}
            rows={3}
            className="border border-gray-200 rounded-lg px-3 py-2.5 text-sm text-gray-800 placeholder-gray-400 focus:outline-none focus:border-[#BD0043] transition-colors bg-white w-full resize-none"
          />
        </div>

        <hr className="border-gray-100" />

        <div className="flex items-center gap-2">
          <Checkbox
            id="hide_sender_check"
            checked={cardForm?.show_sender_name == 1}
            onChange={(e) => {
              if (e.target.checked) {
                setCardForm({ ...cardForm, show_sender_name: 1 });
              } else {
                setCardForm({ ...cardForm, show_sender_name: 0 });
              }
            }}
            sx={{
              padding: 0,
              color: "#D1D5DB",
              "&.Mui-checked": { color: "#BD0043" },
            }}
          />
          <label
            htmlFor="hide_sender_check"
            className="text-sm text-gray-700 cursor-pointer select-none"
          >
            {t("dontshownameoncart")}
          </label>
        </div>

        <div className="flex flex-row xs:flex-col gap-4 w-full">
          
          <div className="flex flex-col gap-1 flex-1">
            <label className="text-sm text-gray-700 font-medium">
              {t("senderName")}
            </label>
            <input
              type="text"
              placeholder={t("senderName") || "Enter name"}
              value={cardForm?.sender_name}
              onChange={(e) => {
                setCardForm({
                  ...cardForm,
                  sender_name: CUSTOM.strFormat(e.target.value, "max:50"),
                });
              }}
              className="border border-gray-200 rounded-lg px-3 py-2.5 text-sm text-gray-800 placeholder-gray-400 focus:outline-none focus:border-[#BD0043] transition-colors bg-white w-full"
            />
          </div>

          <div className="flex flex-col gap-1 flex-1">
            <label className="text-sm text-gray-700 font-medium">
              {t("shareYourFeelingsWithA") || "Share your feelings with"}
            </label>
            <div
              className={`flex flex-row items-center border rounded-lg overflow-hidden focus-within:border-[#BD0043] transition-colors bg-white ${
                errors?.link ? "border-red-400" : "border-gray-200"
              }`}
            >
              <span className="px-3 shrink-0">
                <Img
                  src="/images/img_iconeditorinsertlink.svg"
                  alt="link"
                  className="h-5 w-5"
                />
              </span>
              <input
                type="url"
                placeholder={t("pasteALinkToASongOrVideo") || "Paste a link to song or video"}
                value={cardForm?.link}
                onChange={(e) => {
                  setCardForm({
                    ...cardForm,
                    link: CUSTOM.strFormat(e.target.value, "max:500"),
                  });
                }}
                className="px-2 py-2.5 text-sm text-gray-800 placeholder-gray-400 focus:outline-none bg-transparent w-full"
              />
            </div>
            {errors?.link && (
              <span className="text-xs text-red-500 mt-0.5">{errors.link}</span>
            )}
          </div>
        </div>

        <button
          type="button"
          onClick={GiftOpenclick}
          disabled={disabledBtn}
          className={`w-full py-3.5 rounded-xl text-[16px] font-semibold ${headingClass} transition-all mt-2
            ${
              !disabledBtn
                ? "bg-[#771237] text-[white] hover:bg-[#5e0e2c] cursor-pointer shadow-md"
                : "bg-[#771237] text-[white] cursor-not-allowed opacity-50"
            }`}
        >
          {t("continue")}
        </button>

        {/* ─── OLD UI - commented out, preserved below ─── */}
        {/* 
        <div className="mt-2.5 w-full">
          <Text className="text-base text-black-900 font-nunitomedium mb-6">
            {t("sendAsAGift")}
          </Text>
          <div className="w-full">
            <div className="bg-light_blue-50 flex flex-row gap-3 items-center justify-start p-3 my-6 rounded w-full">
              <Img
                className="h-6 ml-2 rtl:ml-0 rtl:mr-2 sm:ml-[0] w-6"
                src="/images/img_antdesigninfo_black_900.svg"
                alt="antdesigninfo"
              />
              <Text className="leading-4 text-black-900 text-xs w-full font-nunitoregular max-w-[80%]">
                {t("onlyTheRecipientMayChooseTheDeliveryDateTimeAndPlaceWhenGivingTheseItemsAsGift")}
              </Text>
            </div>
            <div className="w-full flex flex-row gap-x-5 xs:flex-col">
              <Input required label={t("recipientName")} value={cardForm?.recipient_name}
                onChange={(e) => { setCardForm({ ...cardForm, recipient_name: CUSTOM.strFormat(e.target.value, "max:50") }); }} />
              <MobileInput required label={t("whatsappMobileNumber")} value={cardForm?.mobile_no}
                onChange={(e) => { setErrors({}); setCardForm({ ...cardForm, mobile_no: CUSTOM.strFormat(e.target.value, "max:9|number") }); }}
                error={errors?.mobile_no} />
            </div>
            <div className="w-full flex flex-row gap-x-5 xs:flex-col">
              <Input label={t("email")} value={cardForm?.email}
                onChange={(e) => { setCardForm({ ...cardForm, email: CUSTOM.strFormat(e.target.value, "max:100") }); }} />
              <div className="w-full">
                <SelectBoxNew required options={occasionOptions} label={t("occasion*")} value={cardForm?.occasion_id}
                  onChange={(e) => { setoccasion(e.target.value); }} />
                <Button className="flex flex-1 flex-row items-center justify-start w-full gap-2 relative top-[-20px]"
                  onClick={(e) => { setAddToMyOccasionAddNewOpen(true); }}>
                  <Img className="h-6 w-6" src="/images/img_plus_pink_800.svg" alt="location" />
                  <Text className="common-pointer text-center text-pink-800 text-sm w-auto font-nunitomedium">
                    {t("addNewOccasion")}
                  </Text>
                </Button>
              </div>
            </div>
            <div className="w-full flex flex-row gap-x-5 xs:flex-col">
              <Input required multiline minRows={3} value={cardForm?.message} label={t("typeYourCardMessageHere")}
                onChange={(e) => { setCardForm({ ...cardForm, message: CUSTOM.strFormat(e.target.value, "max:180") }); }} />
            </div>
            <div className="w-full flex flex-row items-center gap-x-5 mb-6">
              <Checkbox checked={cardForm?.show_sender_name == 1}
                onChange={(e) => { if (e.target.checked) { setCardForm({ ...cardForm, show_sender_name: 1 }); } else { setCardForm({ ...cardForm, show_sender_name: 0 }); } }} />
              <Text className="text-base text-black-900 font-nunitomedium">{t("dontshownameoncart")}</Text>
            </div>
            <div className="w-full flex flex-row gap-x-5 xs:flex-col">
              <Input label={t("senderName")} value={cardForm?.sender_name}
                onChange={(e) => { setCardForm({ ...cardForm, sender_name: CUSTOM.strFormat(e.target.value, "max:50") }); }} />
            </div>
            <div className="w-full flex flex-row gap-x-5 xs:flex-col">
              <Text className="text-base text-black-900 font-nunitomedium mt-2">{t("shareYourFeelingsWithA")}</Text>
            </div>
            <div className="w-full flex flex-row gap-x-5 mt-3 xs:flex-col">
              <Input
                startAdornment={<Img className="mr-3 rtl:mr-0 rtl:ml-3 mt-1" src="/images/img_iconeditorinsertlink.svg" alt="" />}
                value={cardForm?.link}
                onChange={(e) => { setCardForm({ ...cardForm, link: CUSTOM.strFormat(e.target.value, "max:500") }); }}
                placeholder={t("pasteALinkToASongOrVideo")} />
            </div>
            <div className="w-full max-w-[175px] mt-3 flex flex-row gap-4 mb-[18px]">
              <Button className="flex-1 mx-auto min-w-[100px]" size="lg" variant="FillBlack" hover={true}
                hoverclass="bg-white-A700" disabled={disabledBtn} onClick={GiftOpenclick}>
                {t("continue")}
              </Button>
            </div>
          </div>
        </div>
        */}

      </div>
            {/* <Button
              className="w-auto min-w-[140px] mx-auto xs:min-w-[unset] xs:w-full"
              size="lg"
              variant="OutlineBlack"
              onClick={GiftOpenclick}
              disabled={disabledBtn}
              hover={true}
              hoverclass="bg-black-900"
            >
              {t("preview")}
            </Button> */}
      {/* ─────────────────────────────────────────────────────────── */}

      {giftOpen === true ? (
        <Gift
          closepopup={setgiftOpen}
          saveGiftData={saveGiftData}
          Giftdata={cardForm}
          type="previewCard"
          printRef={printRef}
        />
      ) : null}

      {addToMyOccasionAddNewOpen && (
        <AddToMyOccasionAddNew
          closepopup={setAddToMyOccasionAddNewOpen}
          modalTopIcon="/images/add_to-occasion-icon.svg"
          OccasionTitle={t("addNewOccasion")}
          OccasionParagraph={t("enterBelowDetailsToAddANewOccasionDot")}
        />
      )}
    </>
  );
};

export default SendAsAGift;
